import { APICallV3Get } from 'reactApp/api/APICall';
import type { BillingDataArgs, BillingDataResponse } from 'reactApp/api/billing/data/BillingDataAPICall.types';

class BillingDataAPICall extends APICallV3Get<BillingDataResponse, BillingDataArgs> {
    _method = 'billing/data';
}

export const BillingDataCoreApi = {
    makeRequest: (args: BillingDataArgs) => new BillingDataAPICall().makeRequest(args),
} as const;
